export const Bio = {
    FirstName: "Abdessamad",
    LastName: "AIT HAMOU",
    roles: [
      "Full Stack Developer",
      "Mobile Developer",
      "Programmer",
      "Space Enthusiast"
    ],
    description:
      ".NET Software Engineer experienced in building scalable web applications and microservices. Skilled in backend development with .NET, NodeJs and modern technologies. Passionate about software architecture and cloud-native solutions.",
    github: "https://github.com/AHabdessamad",
    resume:
      "https://drive.google.com/file/d/1fqiu6GqevOx6nbl6oYz6PUjOyYo2N2ec/view",
    linkedin: "www.linkedin.com/in/abdessamad-ait-hamou-3b36a9211",
    twitter: "https://twitter.com/Ait7Abdessamad",
    insta: "https://www.instagram.com/ah_abdessamad/",
    facebook: "https://web.facebook.com/profile.php?id=100008353416359",
    email: "abdessamadaithamou0@gmail.com",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Nextjs",
          image: "https://images.ctfassets.net/23aumh6u8s0i/6pjUKboBuFLvCKkE3esaFA/5f2101d6d2add5c615db5e98a553fc44/nextjs.jpeg"
        },
        {
          name: "Redux",
          image:
            "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://www.bryan-myers.com/images/4x3/css.png",
        },
        {
          name: "JavaScript",
          image:
            "https://skillforge.com/wp-content/uploads/2020/10/javascript.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Material UI",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "Tailwindcss",
          image:
           "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
        },
        {
          name: "Blazor",
          image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/blazor/blazor-original.svg"
        }
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: '.Net',
          image: "https://upload.wikimedia.org/wikipedia/commons/e/ee/.NET_Core_Logo.svg"
          
        },
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
         {
          name: "Nest Js",
          image: "https://upload.wikimedia.org/wikipedia/commons/a/a8/NestJS.svg",
        },
        {
          name: "Express Js",
          image:
            "data:image/png;base64,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",
        },
        {
          name: "Spring Boot",
          image:
            "https://spring.io/img/logos/spring-initializr.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "MongoDB",
          image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
        {
          name: "SQL Server",
          image: "https://www.snaresolutions.com/wp-content/uploads/Snare_Central-Log-Management_Website-Images_Database-Activity-Monitoring-1030x900.png",
        },
        // {
        //   name: "Postgresql",
        //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        // },
      ],
    },
    {
      title: "Ecommerce & CMS",
      skills: [
        {
          name: "Optimizely CMS",
          image: "https://upload.wikimedia.org/wikipedia/en/e/e9/Optimizely_Logo.png"
        },
        {
          name: "Contentful",
          image: "https://raw.githubusercontent.com/contentful/contentful.js/HEAD/images/contentful-icon.png"
        },
        {
          name: "Sanity",
          image: "https://avatars.githubusercontent.com/u/17177659?s=200&v=4"
        },
        {
           name: "OrderCloud",
           image: "https://avatars.githubusercontent.com/u/20692088?s=200&v=4"
        },
      ]
    },
    {
      title: "Android",
      skills: [
        {
          name: "Kotlin",
          image:
            "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
        },
        {
          name: "Android Studio",
          image:
            "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
        },
        {
          name: 'MAUI',
          image: 'https://lightningchart.com/wp-content/uploads/images/icons/maui-logo.svg'

        }
      ],
    },
    {
      title: "Tools & AI",
      skills: [
        {
          name: "Git",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Postman",
          image:
          "https://play-lh.googleusercontent.com/MET411zZK3fH8Z4YjQR9iBrKEaqQKL-5UwOk2f0QGA2rp6L14AeQSDsvQR8wS1t8aJpulXrCXrtzTh3MsZ6VXeE",
        },
        {
          name: "VS Code",
          image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: 'IntelliJ',
          image: "https://upload.wikimedia.org/wikipedia/commons/9/9c/IntelliJ_IDEA_Icon.svg"
        },
        {
          name: "Copilot (Chat/CLI)",
          image: "https://karankrishnani.com/images/copilot-logo.png"
        },
        {
          name: "Prompt Engineering",
          image: "https://logo.promptengineering.rocks/assets/prompt-engineering-logo.png"
        }
        // {
        //   name: "Docker",
        //   image:
        //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        // },
      ],
    },
  ];
 
  export const certifications = [
    {
      id: 1,
      title: "C# Mastering Course For Intermediates",
      issuer: "Udemy",
      year: "2024",
      link: "https://udemy-certificate.s3.amazonaws.com/image/UC-14f899f7-5260-49c2-a854-86c554e53b4c.jpg",
    },
    {
      id: 2,
      title: "Udemy .Net 8 Microservice",
      issuer: "Udemy",
      year: "2025",
      link: "https://udemy-certificate.s3.amazonaws.com/image/UC-392dee00-2f8f-41df-ad8a-6d99b1c3a546.jpg",
    },
    {
      id: 3,
      title: "Microsoft Certified: Azure Fundamentals",
      issuer: "Microsoft",
      year: "2025",
      link: "https://learn.microsoft.com/enus/users/abdessamadaithaou-4883/credentials/a16602d7ac59ac7a?ref=https%3A%2F%2Fwww.linkedin.com%2F",
    },
    {
      id: 4,
      title: "GitHub Copilot - AI for Coding & Development",
      issuer: "Udemy",
      year: "2026",
      link: "https://udemy-certificate.s3.amazonaws.com/image/UC-7f2d0aaf-ce80-4c1b-9ac6-1f93071f59fd.jpg?v=1774430033000",
    },
    {
      id: 5,
      title: "Foundational C# with Microsoft",
      issuer: "FreeCodeCamp & Microsoft",
      year: "2025",
      link: "https://www.freecodecamp.org/certification/abdessamad-ait-hamou/foundational-c-sharp-with-microsoft",
    },
    {
      id: 6,
      title: "Version Control",
      issuer: "Coursera",
      year: "2023",
      link: "https://www.coursera.org/account/accomplishments/certificate/XP7XNNCR2FGL",
    },
    {
      id: 7,
      title: "Optimizely Opal Tools",
      issuer: "Credly / Optimizely",
      year: "2025",
      link: "https://www.credly.com/badges/a2983f9a-64bb-482c-bb5b-2d4fa7243188/public_url",
    },
    {
      id: 8,
      title: "Mastering PostgreSQL: The Ultimate SQL Guide",
      issuer: "Udemy",
      year: "2024",
      link: "https://udemy-certificate.s3.amazonaws.com/image/UC-d4a24425-bc4b-4e16-a018-b70939af5de1.jpg",
    },
    {
      id: 9,
      title: "HTML,CSS and Javascript for Web Developers",
      issuer: "Coursera",
      year: "2024",
      link: "https://www.coursera.org/account/accomplishments/certificate/XP7XNNCR2FGL",
    },
  ];

  export const experiences = [
    {
      id: 1,
      role: ".Net Full Stack Developer",
      company: "SQLI Nordics",
      startDate: "September 2025",
      endDate: "Present",
      isCurrent: true,
      descriptions: [
        "Contributed to building a composable e-commerce platform using .NET 10 and Next.js",
        "Customized CMS-driven e-commerce experiences (content + commerce integration)",
        "Contributed to an OrderCloud Configurator to automate environment setup",
      ],
      tags: [".Net", "C#", "Next.js", "TypeScript", "Playwright", "CMS Integration", "Microservice", "Docker", "Azure & Vercel", "Agile (Scrum)"],
    },
    {
      id: 2,
      role: ".Net Backend Developer Intern",
      company: "SQLI Morocco & Nordics",
      startDate: "May 2025",
      endDate: "September 2025",
      isCurrent: false,
      descriptions: [
        "Contributed to build a B2C e-commerce platform with product catalog, shopping cart, checkout process, and payment processing",
        "Integrated multiple third-party services including Klarna and Adyen payments, Ingrid shipping",
      ],
      tags: [".NET", "C#", "Optimizely CMS", "Next.js", "Ignite Framework", "SSMS", "Agile (Scrum)"],
    },
    {
      id: 3,
      role: "Full Stack Developer Intern",
      company: "AIMPACTIFY Maroc",
      startDate: "May 2024",
      endDate: "August 2024",
      isCurrent: false,
      descriptions: [
        "Migration of backend of a SaaS to a modular architecture, improving system scalability and maintainability",
        "Development of an AI-Powered email marketing campaign microservice, supporting over 25 active clients",
      ],
      tags: ["MERN Stack", "NestJs", "GPT API Integration", "MongoDB", "Jira", "Scrum"],
    },
    {
      id: 4,
      role: ".Net Backend Developer Intern",
      company: "University of Cady Ayyad (ENSAS)",
      startDate: "December 2023",
      endDate: "February 2024",
      isCurrent: false,
      descriptions: [
        "Participated in maintenance and enhancement of an existing finance application, enabling report management for 43+ professors, from creation to archiving",
        "Migrated the application from .NET Core 3.1 to .NET 6 and refactored and optimized backend code",
      ],
      tags: ["ASP.NET MVC", "C#", "Rotativa", "SSMS", "Git & Github", "Agile (Scrum)"],
    },
  ];

  export const projects = [
    {
      id: 0,
      title: "ActInSpace Morocco 2026 Champions",
      date: "January 2026",
      description:
        "A SaaS platform democratizing space situational awareness for universities, startups, and small CubeSat operators. It provides real-time orbital monitoring, collision risk alerts, satellite health analytics, and maneuver simulation",
      image:
        "imgs/ActInSpace.png",
      tags: [
        "Nextjs",
        "Algorithms",
        "Python",
        "Docker",
        "Redis",
        "PostgreSQL",
        "Teamwork"
      ],
      category: "web",
      website: "https://www.orbitalnexus.space/",
    },
    {
      id: 1,
      title: "Global Nominee project: BreatheWise",
      date: "October 2025",
      description:
        "web-based application that forecasts air quality across North America using real-time data from NASA’s TEMPO mission, ground-based air quality sensors, and weather datasets. The platform notifies users of poor air conditions and supports better public health decisions by providing accurate, real-time pollution insights.",
      image:
        "imgs/BreatheWise.png",
      tags: [
        "Nextjs",
        "n8n automation",
        "Tailwind",
        "Azure",
        "Twilio",
        "Teamwork"
      ],
      category: "web",
      website: "https://airadata.earth/",
    },
    {
      id: 2,
      title: "Laforain Imobilier",
      date: "Jun 2023 -  Jul 2023",
      description:
        "Full Stack web Application for a real estate company that allows users  to explore, list, and interact with real estate properties. ALso prviding a Robust Dashboard to manage overall website content.",
      image:
        "imgs/houserent.png",
      tags: [
        "HTML",
        "JavaScript",
        "CSS",
        "PHP",
        "MySQL"
      ],
      category: "web",
      github: "https://github.com/AHabdessamad/Laforain_Immobilier",
    },
    {
      id: 2,
      title: "Prof Missions Manager",
      date: "Dec 2023 - Mar 2024",
      description:
      "School Administration Platform for managing missions for teachers in order to get reimbursements.",
      image:
      "imgs/ProfMission.png",
      tags: [
        "ASP.Net Core MVC",
        "C#",
        "EF",
        "SQL Server (SSMS)",
        "JQuery",
      ],
      type: "web",
      github: "https://github.com/AHabdessamad/Brain-Tumor-Detection",
    },
    {
      id: 3,
      title: "Brain Tumor Detection",
      date: "Nov 2023 - Dec 2023",
      description:
        "Creating a user interface (UI) using .NET Windows Forms, allowing the user to upload human brains images and detect the presence of brain tumors and classify them into one of the three types: Meningioma, Pituitary, Glioma.",
      image:
        "imgs/BrainTumor.png",
      tags: [
        "WPF",
        ".NET ML",
        "C#",
        "Python",
        "Tensorflow",
      ],
      type: "web",
      github: "https://github.com/AHabdessamad/Brain-Tumor-Detection",
    },
  {
    id: 4,
    title: "Restfull API",
    date: "Sep 2023 - Nov 2023",
    description:
      "Build a REST API using Stateless communication via NodeJs, ExpressJs, and MongoDB, tested using Postman.",
    image:
      "imgs/RESTapi.png",
    tags: [
      "NodeJs",
      "ExpressJs",
      "MongoDB",
      "Postman",
    ],
    type: "web",
    github: "https://github.com/AHabdessamad/Brain-Tumor-Detection",
  },
  {
    id: 5,
    title: "News APP",
    date: "Nov 2023 - Dec 2023",
    description:
      "Mobile app for reading news around the world with four pages (Headlines/Search/Saved/Profile).",
    image:
      "imgs/newsApp.jpg",
    tags: [
      "Kotlin",
      "Android Studio",
      "Firebase",
      "SQLite",
      "MVVM",
    ],
    type: "mobile",
    github: "https://github.com/AHabdessamad/Guardian_News_App",
  },

  ]
 
